<template>
  <div class="w-full flex bg-white overflow-hidden">
    <div class="flex items-center w-full">
      <div class="w-4/12 p-16">
        <h1 class="text-3xl text-dark font-semibold">Brand Profile</h1>
        <p class="fsize14 text-gray mb-0">
          Setup your brands logos and trademarks.
        </p>
        <div class="shadow-lg border-round mt-8 px-8 pt-8 pb-16 relative">
          <div>
            <small class="text-sm text-primary font-semibold">Step 1</small>
            <h1 class="fsize21 col-4f mb-0 font-semibold">Brand Logo</h1>
            <p class="fsize14 col-4f mb-0">Upload your Brand Logo</p>
          </div>
          <div class="grid grid-cols-1 gap-4 mt-6 gap-3">
            <div class="w-full items-center relative">
              <div class="relative cursor-pointer">
                <div
                  class="flex w-full items-center relative cursor-pointer mb-4"
                >
                  <div class="relative z-10 w-2/12 cursor-pointer">
                    <img
                      ref="primaryRef"
                      @load="getColorCode()"
                      :src="
                        primaryImageSource
                          ? primaryImageSource
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="rounded-full w-16 h-16 bg-gray"
                    />
                    <div
                      class="absolute new-hew bottom-0 z-50 right-0 rounded-full"
                    >
                      <input
                        type="file"
                        ref="fileInput1"
                        @change="uploadPrimary"
                        class="opacityu"
                        accept="image/jpg,image/jpeg,image/png"
                      />
                    </div>
                    <div class="absolute bottom-0 z-30 right-0">
                      <img
                        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                        alt="image"
                        class=""
                      />
                    </div>
                  </div>
                  <div class="w-10/12 pl-6">
                    <div>
                      <h2 class="text-dark fsize16 mb-0 mt-3">
                        Primary Logo <span class="text-danger">*</span>
                      </h2>
                      <p class="fsize10 col-4f flex items-center">
                        Logo for Lighter backgound
                      </p>
                    </div>
                  </div>
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    primaryImageSource === "" ? "This Field is required" : ""
                  }}
                </p>
                <div class="flex w-full items-center cursor-pointer mb-4">
                  <div class="relative z-10 w-2/12">
                    <img
                      :src="
                        secondaryImageSource
                          ? secondaryImageSource
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="rounded-full w-16 h-16"
                    />
                    <div class="absolute new-hew bottom-0 z-50 right-0">
                      <input
                        type="file"
                        ref="fileInput1"
                        @change="uploadSecondary"
                        accept="image/jpg,image/jpeg,image/png"
                        class="opacityu"
                      />
                    </div>
                    <div class="absolute bottom-0 z-30 right-0">
                      <img
                        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                        class=""
                      />
                    </div>
                  </div>

                  <div class="w-10/12 pl-6">
                    <div>
                      <h2 class="text-dark fsize16 mb-0 mt-3">
                        Alternate Logo
                      </h2>
                      <p class="fsize10 col-4f flex items-center">
                        Logo for Lighter backgound
                      </p>
                    </div>
                  </div>
                </div>
                <div class="flex w-full items-center cursor-pointer mb-4">
                  <div class="relative z-10 w-2/12">
                    <img
                      :src="
                        tertiaryImageSource
                          ? tertiaryImageSource
                          : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                      "
                      class="rounded-full w-16 h-16"
                    />
                    <div class="absolute new-hew bottom-0 z-50 right-0">
                      <input
                        type="file"
                        ref="fileInput1"
                        @change="uploadTertiary"
                        accept="image/jpg,image/jpeg,image/png"
                        class="opacityu"
                      />
                    </div>
                    <div class="absolute bottom-0 z-30 right-0">
                      <img
                        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/up.png"
                        class=""
                      />
                    </div>
                  </div>
                  <div class="w-10/12 pl-6">
                    <div>
                      <h2 class="text-dark fsize16 mb-0 mt-3">
                        Favicon <span class="text-danger">*</span>
                      </h2>
                      <p class="fsize10 col-4f flex items-center">
                        Logo for Lighter backgound
                      </p>
                    </div>
                  </div>
                </div>
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{
                    tertiaryImageSource === "" ? "This Field is required" : ""
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <el-checkbox v-model="checked"
              >Proceed with a temporary logo</el-checkbox
            >
          </div>
          <div
            class="absolute bottom-0 margin-niche right-0 left-0 w-full flex justify-between"
          >
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Default.svg"
                class="mar-left"
                @click="handleClick('hello')"
              />
            </div>
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class="mar-right"
                @click="handleClick('business')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-8/12 bg-primary pt-24 pl-32 relative">
        <div class="relative z-50 pl-10 pt-20">
          <!-- <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/frame.png"
            class="height-website w-full"
          /> -->
          <div
            class="bg-f4f5f6 webborder12px parentweb height-website shadow-lg"
          >
            <div
              class="w-full py-6 px-12 bg-white items-center flex justify-between"
            >
              <img
                :src="
                  primaryImageSource
                    ? primaryImageSource
                    : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                "
                this.brandProfile.primaryLogo
                class="w-12 h-12 rounded-md object-contain"
                alt="logo"
              />

              <h1 class="text-black text-2xl font-bold mb-0">Home</h1>
              <h1 class="text-black text-2xl font-bold mb-0">About</h1>
              <h1 class="text-black text-2xl font-bold mb-0">Connect</h1>
            </div>
          </div>
          <div class=""></div>
          <div class="absolute bottom-0 right-0">
            <div class="bg-dark second-website pt-4 pl-4 shadow-lg">
              <div
                class="w-full py-6 px-12 bg-glass items-center flex justify-between"
              >
                <img
                  :src="
                    secondaryImageSource
                      ? secondaryImageSource
                      : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                  "
                  class="w-12 h-12 rounded-md object-contain"
                  alt="logo"
                />
                <h1 class="text-white text-2xl font-bold mb-0">Home</h1>
                <h1 class="text-white text-2xl font-bold mb-0">About</h1>
              </div>
            </div>
            <div class="absolute top-0 left-0">
              <div class="grid grid-cols-1 gap-4">
                <marquee
                  class="bg-transparent text-white font-semibold mb-0"
                  scrollamount="7"
                >
                  <div class="grid grid-cols-1 gap-5">
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name3.png"
                      class="w-full height-marf"
                    />
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name3.png"
                      class="w-full height-marf"
                    />
                    <img
                      src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name3.png"
                      class="w-full height-marf"
                    />
                  </div>
                </marquee>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import ColorThief from "colorthief";
export default {
  data() {
    return {
      colorCode: [],
      primaryImage: "",
      primaryChange: false,
      primaryImageSource: "",
      secondaryImage: "",
      secondaryChange: false,
      secondaryImageSource: "",
      tertiaryImage: "",
      tertiaryChange: false,
      tertiaryImageSource: "",
      checked: false,
      submitted: false,
      primaryDefaultImage:
        "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/logo-light.png",
      secondaryDefaultImage:
        "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/logo-light.png",
      tertiaryDefaultImage:
        "https://nimbus-server-01.s3.ap-south-1.amazonaws.com/download/favicon-default.png",
      completed: false,
    };
  },
  computed: {
    ...mapState("brandProfile", {
      brandProfile: "brandProfile",
    }),
    ...mapState("user", { selectedProject: "selectedProject" }),
  },
  methods: {
    IScompleted() {
      if (this.completed === true) {
        this.$router.push({ name: "dashboard" });
      }
    },
    async handleClick(name) {
      this.submitted = true;
      let formData = new FormData();
      formData.append("projectId", this.selectedProject._id);
      formData.append("projectName", this.selectedProject.projectName);
      formData.append(
        "path",
        `${this.selectedProject.projectName}/brandProfile`
      );
      if (this.primaryImage && this.primaryChange) {
        formData.append("primaryLogo", this.primaryImage);
      }

      if (this.secondaryImage && this.secondaryChange)
        formData.append("alternateLogo", this.secondaryImage);

      if (this.tertiaryImage && this.tertiaryChange)
        formData.append("favIcon", this.tertiaryImage);
      if (
        this.checked === true &&
        name === "business" &&
        (this.primaryImage === "" || this.primaryImage !== "") &&
        (this.secondaryImage === "" || this.secondaryImage !== "") &&
        (this.tertiaryImage === "" || this.tertiaryImage !== "")
      ) {
        this.submitted = false;
        this.primaryImage = "";
        this.secondaryImage = "";
        this.tertiaryImage = "";
        this.$router.push({ name: name });
        console.log(brandProfile);
      }
      if (
        this.checked === false &&
        name === "business" &&
        (this.primaryImage !== "" || this.primaryImageSource !== "") &&
        (this.tertiaryImage !== "" || this.tertiaryImageSource !== "")
      ) {
        await this.$store.dispatch("brandProfile/uploadBrandProfile", formData);
        this.$store.commit("brandProfile/COLOR_CODE", this.colorCode);
        this.$router.push({ name: name });
      }
    },

    async uploadPrimary(e) {
      this.primaryChange = true;
      console.log(e.target.files);
      this.primaryImage = e.target.files[0];

      const reader = new FileReader();
      this.primaryImageSource = await this.convertToBase64(e.target.files[0]);
      console.log(this.primaryImageSource);
    },
    async uploadSecondary(e) {
      this.secondaryChange = true;
      this.secondaryImage = e.target.files[0];

      const reader = new FileReader();
      this.secondaryImageSource = await this.convertToBase64(e.target.files[0]);
      console.log(this.secondaryImageSource);
    },

    async uploadTertiary(e) {
      this.tertiaryChange = true;
      this.tertiaryImage = e.target.files[0];
      const reader = new FileReader();
      this.tertiaryImageSource = await this.convertToBase64(e.target.files[0]);
      console.log(this.tertiaryImageSource);
    },

    convertToBase64(file) {
      return new Promise(async (resolve, reject) => {
        let reader = new FileReader();
        await reader.readAsDataURL(file);

        reader.onloadend = await function () {
          resolve(reader.result);
        };
      });
    },
    async getColorCode() {
      this.colorCode = [];
      try {
        console.log("call");
        let image = this.$refs.primaryRef;
        let color = new ColorThief();
        let colorPal;
        colorPal = color.getPalette(image, 5);
        colorPal.forEach((c) => {
          let style = {
            backgroundColor: "rgb(" + c[0] + "," + c[1] + "," + c[2] + ")",
            hex:
              `#` +
              `${
                c[0].toString(16).length === 1
                  ? "0" + c[0].toString(16)
                  : c[0].toString(16)
              }` +
              `${
                c[0].toString(16) + c[1].toString(16).length === 1
                  ? "0" + c[1].toString(16)
                  : c[1].toString(16)
              }` +
              `${
                c[2].toString(16).length === 1
                  ? "0" + c[2].toString(16)
                  : c[2].toString(16)
              }`,
          };
          this.colorCode.push(style);
        });

        console.log(colorPal, "uwuwu1");
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    console.log(this.brandProfile);
    // this.getColorCode();
    let imageBaseURL = this.$imageURL + "/";
    if (this.brandProfile.primaryLogo)
      this.primaryImageSource = imageBaseURL + this.brandProfile.primaryLogo;

    if (this.brandProfile.alternateLogo)
      this.secondaryImageSource =
        imageBaseURL + this.brandProfile.alternateLogo;

    if (this.brandProfile.favIcon)
      this.tertiaryImageSource = imageBaseURL + this.brandProfile.favIcon;

    this.completed = this.brandProfile.isCompleted;
    // this.IScompleted();
  },
};
</script>
<style>
el-checkbox__input.is-checked + .el-checkbox__label {
  color: gray !important;
}
</style>
